export default {
  name: /^(([0-9]|[A-Z])[0-9A-Za-z.()']*)(\s([0-9(]|[A-Z(])[0-9A-Za-z.()']*)*?$/,
  case_number: /^(([0-9A-Za-z])[0-9A-Za-z.()']*)(\s([0-9(]|[A-Za-z(])[0-9A-Za-z.()']*)*?$/
};
